import './apps/outlook/src/polyfills.ts';